<script lang="ts">
  import type {Poem} from '../../src/types'

  export let poem: Poem

  function encode(text: string) {
    return encodeURIComponent(text)
  }

  function popupCenter(url: string) {
    const w = window
    const d = window.document
    const _w = 600
    const _h = 400
    const dualScreenLeft = typeof w.screenLeft !== 'undefined' ? w.screenLeft : (screen as any).left,
      dualScreenTop = typeof w.screenTop !== 'undefined' ? w.screenTop : (screen as any).top,
      width = w.innerWidth || d.documentElement.clientWidth || screen.width,
      height = w.innerHeight || d.documentElement.clientHeight || screen.height,
      left = ((width / 2) - (_w / 2)) + dualScreenLeft,
      top = ((height / 3) - (_h / 3)) + dualScreenTop,
      windowFormat = 'resizable,toolbar=yes,location=yes,scrollbars=yes,menubar=yes,width={0},height={1},top={2},left={3}',
      newWindow = w.open(url, '', stringFormat(windowFormat, [_w, _h, top, left]))

    if (newWindow !== null && newWindow.focus) {
      newWindow.focus()
    }
  }

  function stringFormat(str: string, args: any) {
    return str.replace(/\{(\d+)}/g, function (m, n) {
      return args[n] || m
    })
  }

  function onClick(e: Event, url: string) {
    e.preventDefault()
    popupCenter(url)
  }

  $: url = location.origin + '/poems/' + poem.handle
  $: title = encode(poem.title)

  $: fbLink = `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${title}`
  $: twLink = `https://twitter.com/intent/tweet?url=${url}&text=${title}`
</script>

<div>
  <a class="share-btn" onclick={e => onClick(e, fbLink)} href={fbLink}>
    <i class="socicon-facebook"></i> Facebook
  </a>

  <a class="share-btn" onclick={e => onClick(e, twLink)} href={twLink}>
    <i class="socicon-twitter"></i> Twitter
  </a>
</div>